import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["siren", "checkbox", "price"]

  connect() {
    if (this.hasCheckboxTarget) this.toggle()
  }

  toggle() {
    if (!this.hasCheckboxTarget || !this.hasSirenTarget) return

    const checked = this.checkboxTarget.checked
    this.sirenTarget.classList.toggle("hidden", !checked)
  }
}
